<template>
  <div class="categories">
    <v-card-text >
      <v-row>
        <v-col cols="3" v-for="item in items" :key="item.Id">
          <div  >
            <div  v-on:click="goToDetail(item.Id)">
              <div class="row" style="text-align: center">
                <div class="col-12">
                  <img style="width: 80%;height: auto;padding: 7px;background: #F3F3F3;border-radius: 10px;" :src="item.ImageUrl" />
                </div>
                <div class="col-12" style="text-align: center">
            <span class="name" style="font-size: 12px;text-align: center;line-height: 1.1rem;color: black;">
              {{item.CategoryTitle}}
            </span>
                </div>
              </div>

            </div>

          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>
<script>
  export default {

    data() {
      return {
        items:[],
        selected_item_id : '',
        errors: [],
        rules: {
          required: value => !!value || 'الزامی',
          fullName: value => value.length <= 30 || 'ماکسیمم 30 کاراکتر می باشد.',
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || 'نام و نام خانوادگی فارسی نیست.'
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || 'فرمت موبایل صحیح نیست.'
          },
        },
      }
    }, watch: {

    },mounted() {
      var passing_data = JSON.parse(localStorage.getItem('request_data'));
     this.selected_item_id =  passing_data.group_id;
      this.get_categories();
    },
    methods: {
      get_item_color(item_id){
        if(item_id==this.selected_item_id){
         return "#cee2f7"
        }else{
          return "white"
        }
      },
      goToDetail (item_id) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'));
        passing_data.group_id = item_id;
        localStorage.setItem("request_data",JSON.stringify(passing_data));
        this.$router.push({ path: 'subgroups', params: {} })
      },
      get_categories() {
        // console.log("datas is "+localStorage.getItem('request_data'))

        var self = this;
        var passing_data = JSON.parse(localStorage.getItem('request_data'));
        var cat_id = passing_data.cat_id;
          const send_data = {
            "pTypeId": cat_id,
          };
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/GetReqTypeCategoryByTypeId', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                // console.log("response", response);
                // self.fullName = response.data.msg;
                self.items = response.data.categories;
                // self.level = 2;
              }
              // this.$router.push({ path: "/post-login", params: {} });

            }).catch(e => {
            this.errors.push(e);

          })

      }
    }
  }
</script>
